import { useFilterValue } from '@btime/react-contexts'
import React from 'react'

import { getSelectedPlaceLevelsValues } from './_helpers/selectedPlaceLevels'
import FilterLink from '../../../components/filter/FilterLink'
import FilterListItem from '../../../components/list/FilterListItem'
import PlaceLevelsFilterSideModal from './PlaceLevelsFilterSideModal'

const PlacesFilter = ({ label, field, icon, presentation, ...props }) => {
  const [open, setOpen] = React.useState(false)

  presentation = presentation || 'bar'
  field = field || 'placeLevelIds'
  label = label || 'Level'
  const value = useFilterValue(field, [])

  const selectedValue = getSelectedPlaceLevelsValues(value, props.type, props.levelId)
  const isSelected = !!selectedValue
  const Link = presentation === 'bar' ? FilterLink : FilterListItem

  return (
    <>
      <Link
        icon={presentation === 'bar' && 'RiMapPinLine'}
        label={label}
        value={selectedValue}
        isSelected={isSelected}
        onClick={() => setOpen(true)}
      />

      <PlaceLevelsFilterSideModal open={open} onClose={() => setOpen(false)} label={label} field={field} {...props} />
    </>
  )
}

export default PlacesFilter
